import {
  Form,
  useBreadcrumbRoutes,
  Wrapper,
  SubContent,
  Button,
  FormTitle,
  Select,
  useAsync,
} from '@maxtropy/components';
import { Col, Row, Space } from 'antd';
import { FC, useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OuStaffType } from '../../../api/const';
import { getRole } from '../../../api/staff';
import OuList, { ChildRef } from './components/OuList';

import styles from './index.module.scss';
import { updateCustomerAuthorityBatch } from '../../../api/customer';
import { InfoCircleOutlined } from '@ant-design/icons';
import UserList, { UserRef } from './components/userList';

const ExternalStaffManage: FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const ouListRef = useRef<ChildRef>(null);
  const userListRef = useRef<UserRef>(null);

  const [loading, setLoading] = useState(false);
  const [selectedMcid, setSelectedMcid] = useState<string>();

  const getRoleRequest = useCallback(async () => {
    form.setFieldValue('roleId', undefined);
    if (selectedMcid) {
      return await getRole(selectedMcid);
    }
    return undefined;
  }, [selectedMcid]);

  const roles = useAsync(getRoleRequest);

  const goList = useCallback(() => {
    navigate(`/system/customer/staff`);
  }, [navigate]);

  const handleClick = () => {
    form.validateFields().then(values => {
      setLoading(true);
      const userData = userListRef.current?.getValue() ?? [];
      const ouData = ouListRef.current?.getValue() ?? [];
      const memberList = ouData.filter(item => item.memberType === OuStaffType.MEMBER)?.map(i => i.id);
      const adminList = ouData.filter(item => item.memberType === OuStaffType.ADMINISTRATOR)?.map(i => i.id);
      updateCustomerAuthorityBatch({
        ...values,
        staffList: userData.map(item => ({ ...item, staffId: item.muid })),
        ouList: [
          { ouMemberType: OuStaffType.MEMBER, ouIds: memberList },
          { ouMemberType: OuStaffType.ADMINISTRATOR, ouIds: adminList },
        ],
      })
        .then(() => {
          navigate(`/system/customer/staff`);
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <Wrapper
      className={styles.wrapperPadding}
      routes={[...(breadcrumbRoutes?.routes ?? []), { name: `开通外部员工权限` }]}
    >
      <FormTitle title="开通外部员工权限" />
      <Form form={form} layout="vertical" validateTrigger={['onBlur']}>
        <SubContent title="外部员工信息">
          <UserList ref={userListRef} setSelectedMcid={setSelectedMcid} selectedMcid={selectedMcid} />
        </SubContent>
        <SubContent title="员工权限">
          <Row>
            <Col span={8}>
              <Form.Item
                label="角色"
                required
                help={
                  <div className={styles.tips}>
                    <InfoCircleOutlined />
                    不分配角色则用户登录并选择此工号后无法访问除用户中心之外的页面
                  </div>
                }
              >
                <Form.Item name="roleId" noStyle rules={[{ required: true, message: '请选择角色' }]}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="请选择角色"
                    showSearch
                    disabled={!selectedMcid}
                    filterOption={(input, option) => option!.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    options={(roles?.list ?? []).map(item => ({ label: item.name, value: item.id }))}
                  />
                </Form.Item>
              </Form.Item>
            </Col>
          </Row>
          <OuList ref={ouListRef} isEdit={true} />
          <Space style={{ marginTop: 24 }}>
            <Button onClick={goList}>取消</Button>
            <Button type="primary" onClick={handleClick} loading={loading}>
              保存
            </Button>
          </Space>
        </SubContent>
      </Form>
    </Wrapper>
  );
};

export default ExternalStaffManage;
